import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { StoreFinderPageInitialData } from "./storeFinderPageInitialData";

export const storeFinderPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.page("store-finder"),
    queryFn: () => fetchOccPageData<PageInitialDataResult<StoreFinderPageInitialData>>("/page-data/store-finder"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
